<template>
    <div>
        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>

        <app-tabela
            idTabela="tblHistoricoAditivos"
            :itens="contratosIndice"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
            :bordered="false"
            :small="false"
        >
            <template slot="vigencia" slot-scope="data">
                {{ data.dtInicioVigencia ? $moment(data.dtInicioVigencia).format('DD/MM/YYYY') : '' }}
                <span v-if="data.dtInicioVigencia">a</span>
                {{ data.dtFimVigencia ? $moment(data.dtFimVigencia).format('DD/MM/YYYY') : '' }}
            </template>
            <template slot="isAditivo" slot-scope="data">
                <app-status :status="data.isAditivo ? 'SIM' : 'NÃO'"></app-status>
            </template>
            <template slot="contratoVigente" slot-scope="data">
                <app-status :status="data.contratoVigente ? 'SIM' : 'NÃO'"></app-status>
            </template>
            <template slot="nuValorGlobalContrato" slot-scope="data">
                {{ data.nuValorGlobalContrato | currency }}
            </template>
        </app-tabela>
    </div>
</template>

<script>
import ContratosServicos from '../ContratosServicos'
import { ordenarHistoricoAditivos } from './historicoAditivosUtils'

export default {
    props: {
        contrato: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            erros: [],
            contratos: [],
            campos: [
                { key: 'index', label: 'Nº', sortable: true, filterable: true, tdClass: 'text-center' },
                { key: 'vcCodigoEstruturado', label: 'Contrato', sortable: true, filterable: true, tdClass: 'text-center' },
                { key: 'vcObjetoContrato', label: 'Objeto', filterable: true },
                { key: 'vigencia', label: 'Vigência', tdClass: 'text-center text-nowrap' },
                { key: 'nuValorGlobalContrato', label: 'Valor Total', tdClass: 'text-right text-nowrap' },
                { key: 'isAditivo', label: 'Aditivo', tdClass: 'text-center' },
                { key: 'tiposAditivo', label: 'Tipos do Aditivo' },
                { key: 'contratoVigente', label: 'Vigente', tdClass: 'text-center' }
            ],
            itensPorPagina: 5
        }
    },

    computed: {
        contratosIndice() {
            // Nº posicional (original = 1, aditivos sequenciais); exibe do mais recente ao mais antigo.
            return ordenarHistoricoAditivos(this.contratos)
                .map((contrato, index) => ({
                    ...contrato,
                    index: index + 1
                }))
                .reverse()
        }
    },

    methods: {
        obterHistoricoAditivos() {
            if (!this.contrato || !this.contrato.contratoId) return

            this.$store.dispatch('addRequest')
            ContratosServicos.obterHistoricoAditivos(this.contrato.contratoId)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.contratos = response.data || []
                        } else {
                            this.erros = response.errors
                        }
                    }
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    created() {
        this.obterHistoricoAditivos()
    }
}
</script>
